export const supportEmailAddress = 'support@zaipayments.com';
export const fallbackErrorMessage = `Something went wrong. Please contact ${supportEmailAddress}`;
export const forbiddenErrorMessage =
  'You do not have permission to perform this action. Please contact your administrator';
